<template>
  <!-- Corpo -->
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <div class="flex justify-center">
      <img
        :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`"
        class="h-20"
      >
    </div>
  </div>
  <div v-if="showInitialMessage">
    <div class="bg-white rounded-lg shadow-md p-6 mb-4">
      <h1 class="text-center text-2xl font-bold">All'uscita, ricordarsi di registrare la propria uscita.</h1>
      <p class="text-center text-1xl">
        Se siete un ospite occasionale, all'uscita,
        Ricordatevi di depositare il badge usato
        nell'apposito contenitore qui affianco.
      </p>
    </div>
    <div class="p-6 flex flex-col lg:flex-row items-center gap-6 justify-center">
      <div class="w-full flex justify-center">
        <div class="flex gap-6 flex-wrap justify-center">
          <button class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition
                      w-full sm:w-48" @click="showInitialMessage = false">
            <img :src="`/images/icons/reception-digitale/ok.png`" class="h-14 mb-2">
            <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">OK</p>
          </button>
          <RichiestaAssistenza />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="bg-white rounded-lg shadow-md p-6 mb-4">
      <h1 class="text-center text-2xl font-bold">Il referente del vostro appuntamento è stato avvisato del vostro arrivo.</h1>
      <p class="text-center text-1xl">
        Attendetelo qui alla Reception.
      </p>
    </div>
  </div>
  <div
    style="position: fixed; bottom: 20px; right: 20px; width: 60px; height: 60px; z-index: 50; cursor: pointer; opacity: 0.1; border: 2px solid #888; border-radius: 12px;"
    @click="easterEggConfirmVisit"
  ></div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import RichiestaAssistenza from '@/Components/RichiestaAssistenza.vue';
import axios from 'axios';

export default {
  layout: LayoutNoHeader,
  props: ['visit'],
  components: {
    Link,
    RichiestaAssistenza
  },
  data() {
    return {
      showInitialMessage: true,
      pollingInterval: null
    };
  },
  mounted() {
    // Start polling every 5 seconds to check visit status
    this.pollingInterval = setInterval(() => {
      this.checkVisitStatus();
    }, 5000);
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    async checkVisitStatus() {
      try {
        const response = await axios.get(route('modules.rd-dettagli-visita', { visit: this.visit.id }));
        
        if (response.data.visit && response.data.visit.confirmed === true) {
          // Clear the polling interval
          clearInterval(this.pollingInterval);
          // Redirect to confirmed page
          router.visit(route('modules.rd-visit-confirmed'));
        }
      } catch (error) {
        console.error('Error checking visit status:', error);
      }
    },
    async easterEggConfirmVisit() {
      try {
        const response = await axios.get(
          route('modules.rd-visit-confirm', { visit: this.visit.id })
        );
        router.visit(route('modules.home', { slug: 'reception-digitale' }));
      } catch (error) {
        console.error('Errore easter egg:', error);
      }
    }
  }
};
</script>
